//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/TaggedObject.js";
import "../Validate/Validate.ValidatorOptions.js";
import "../no/ErrorList.js";
import "../no/Validation.js";
let d=[[[1,"ValidatorOptions",0,"Validate.ValidatorOptions",0]],[[[],"Commit",{R_:{status:''}},0,0],[[],"GetLastErrorListFromCommit",{R_:{errors:"ErrorList"}},0,0],[["fileName"],"AppendPartNode",{},1,0],[["partObject"],"AppendPartNode1",{},1,0],[["fileNames"],"AppendPartNodes",{},1,0],[["partObject"],"AppendPartNodes1",{},1,0],[["index"],"ErasePartNode",{},1,0],[[],"ClearPartNodes",{},0,0],[["index"],"FindPartNode",{R_:{partNode:"Validate.PartNode"}},1,0],[["numberOfPartNodes","partNodes"],"GetPartNodes",{},0,0],[["className"],"AppendCheckerNode",{},1,0],[["classNames"],"AppendCheckerNodes",{},1,0],[["del_ndx"],"EraseCheckerNode",{},1,0],[[],"ClearCheckerNodes",{},0,0],[["index"],"FindCheckerNode",{R_:{checkerNode:"Validate.CheckerNode"}},1,0],[["numberOfCheckerNodes","checkerNode"],"GetCheckerNodes",{},0,0]],[]];
SPLM.Validate.Validator = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.Validator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;